import { sanitizeSvg, hashMarkup, type SanitizedSvg } from "./svg-sanitize";

export interface ParsedSvg extends SanitizedSvg {
  name: string;
  hash: string;
}

export async function fileToParsedSvg(file: File): Promise<ParsedSvg> {
  const isSvg = file.type === "image/svg+xml" || file.name.toLowerCase().endsWith(".svg");
  if (!isSvg) throw new Error("Only .svg files are supported");
  const raw = await file.text();
  const sanitized = sanitizeSvg(raw);
  if (!sanitized) throw new Error("Could not parse SVG file");
  const name = file.name.replace(/\.svg$/i, "") || "Custom SVG";
  return { ...sanitized, name, hash: hashMarkup(sanitized.inner) };
}
